const ITEMS = ["Websites", "Business Cards", "Leaflets", "Brand Identity", "Landing Pages", "Print Design"];

function Row({ hidden = false }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <div key={item} className="flex items-center">
          <span
            className={`font-display text-5xl md:text-7xl px-8 md:px-14 whitespace-nowrap ${
              i % 2 === 0 ? "text-cream" : "italic text-outline"
            }`}
          >
            {item}
          </span>
          <span className="w-2 h-2 rotate-45 bg-gold/70 shrink-0" aria-hidden="true" />
        </div>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section data-testid="marquee" className="border-y border-white/5 py-10 md:py-14 overflow-hidden bg-[#0A0A0A]">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
